import { Pipe, PipeTransform, ElementRef } from '@angular/core';

@Pipe({ name: 'tabindex' })
export class TabIndexPipe implements PipeTransform {
  // Same as Jquery closest function. Search up the DOM tree from given element to find the class selector passed in,
  // Param1 : element to search up from.
  // Param2 : class looking for.
  transform(visible: boolean, el: ElementRef): any {    
    const newTabIndex = visible ? 0 : -1;
    const inputs = document.getElementsByTagName('input');
    const textareas = document.getElementsByTagName('textarea');
    const buttons = document.getElementsByTagName('button');
    const selects = document.getElementsByTagName('select');
    const objects = document.getElementsByTagName('object');
    const div = document.querySelectorAll('div[role="button"]');
    const titleInputs = document.getElementsByClassName('customTabs');
    for (let index = 0; index < inputs.length; ++index) {
      if (el.nativeElement.contains(inputs[index])) {
        inputs[index].tabIndex = newTabIndex;
      }
    }
    for (let index = 0; index < textareas.length; ++index) {
      if (el.nativeElement.contains(textareas[index])) {
        textareas[index].tabIndex = newTabIndex;
      }
    }
    for (let index = 0; index < buttons.length; ++index) {
      if (el.nativeElement.contains(buttons[index]) && !buttons[index].classList.contains('ignore-tab')) {
        buttons[index].tabIndex = newTabIndex;
      }
    }
    for (let index = 0; index < selects.length; ++index) {
      if (el.nativeElement.contains(selects[index])) {
        selects[index].tabIndex = newTabIndex;
      }
    }
    for (let index = 0; index < objects.length; ++index) {
      if (el.nativeElement.contains(objects[index])) {
        objects[index].tabIndex = newTabIndex;
      }
    }

    for (let index = 0; index < div.length; ++index) {
      if (el.nativeElement.contains(div[index])) {
        div[index].setAttribute('tabIndex', newTabIndex.toString());
      }
    }

    // Handle custom tabindex fields.
    for (let index = 0; index < titleInputs.length; ++index) {
      if (el.nativeElement.contains(titleInputs[index])) {
        titleInputs[index].setAttribute('tabIndex', newTabIndex.toString());
      }
    }

    // Handle rogue tabs. Example CKeditor after *ngIf default showing tabindex = 0;
    // If its a legimate tabbable field, above will revert back the tabindex.
    if (!visible) {
      const attrTab = document.querySelectorAll('[tabindex="0"]');
      for (let index = 0; index < attrTab.length; ++index) {
        if (el.nativeElement.contains(attrTab[index])) {
          attrTab[index].setAttribute('tabIndex', '-1');
        }
      }
    }
  }
}
